import type {
  BulkAccessPreview,
  BulkAccessTarget,
} from '~/features/access-control/types/AccessControl';

import { pilot } from '~/services/serviceInstances';

import type { ServerBulkAccessPreview } from './bulkAccessMapper';

import {
  mapBulkAccessPreviewRequest,
  mapBulkAccessPreviewResponse,
} from './bulkAccessMapper';

type Request = {
  targets: BulkAccessTarget[];
};

export const getBulkAccessPreview = async ({
  targets,
}: Request): Promise<BulkAccessPreview> => {
  const serverResponse = await pilot.post<ServerBulkAccessPreview>(
    '/access/bulk/preview/',
    mapBulkAccessPreviewRequest(targets),
  );

  return mapBulkAccessPreviewResponse(serverResponse);
};
